import moment from 'moment';

import { DATE_FORMAT } from '~/utils/helpers/date';

import { CustomField, CustomFieldType } from './types';

type MultiselectOption = {
  label: string;
  value: string;
};

export const formatFieldsValue = (
  formValues: Record<string, string | boolean | MultiselectOption[]>,
  customFields: CustomField[],
) => {
  return Object.keys(formValues).reduce((acc, code) => {
    const value = formValues[code];
    if (value === undefined || value === '') {
      return acc;
    }
    const field = customFields.find((f) => f.code === code);
    switch (field?.inputType.value) {
      case CustomFieldType.BOOLEAN: {
        acc[code] = value === true ? 'true' : 'false';
        return acc;
      }
      case CustomFieldType.NUMBER: {
        acc[code] = String(value).replace(',', '.');
        return acc;
      }
      case CustomFieldType.DATE: {
        acc[code] = moment(String(value), DATE_FORMAT).format('YYYY-MM-DD');
        return acc;
      }
      case CustomFieldType.MULTISELECT: {
        acc[code] = (value as MultiselectOption[]).map((val) => val.value);
        return acc;
      }

      default: {
        acc[code] = String(value);
        return acc;
      }
    }
  }, {} as Record<string, string | string[]>);
};
